import { c as _c } from "react/compiler-runtime";
import { useNotifications } from './context';
import { DEFAULT_ERROR_DURATION, DEFAULT_SUCCESS_DURATION } from './lib/duration';
export interface NotifyHook {
  success: (title: string, duration?: number) => void;
  error: (title: string, duration?: number) => void;
}
export function useNotify() {
  const $ = _c(2);
  const notifications = useNotifications();
  let t0;
  if ($[0] !== notifications) {
    t0 = {
      success: (title, duration) => notifications.add({
        title,
        type: "success",
        duration: duration ?? DEFAULT_SUCCESS_DURATION
      }),
      error: (title_0, duration_0) => notifications.add({
        title: title_0,
        type: "error",
        duration: duration_0 ?? DEFAULT_ERROR_DURATION
      })
    };
    $[0] = notifications;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}